// components/Modal.js

import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ">
      <div className="bg-white p-4 rounded shadow-lg dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
        {/* <button onClick={onClose} className="absolute top-2 right-2 text-gray-500">
          Close
        </button> */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
